import { DESKTOP } from "@/themes/device";
import styled from "@emotion/styled";
import {
  grayScale,
  mHeader1,
  mTitle1,
  wHeader2,
  wTitle1,
} from "@teamsparta/design-system";

export const Wrapper = styled.section`
  width: 328px;
  margin: 0 auto;

  ${DESKTOP} {
    width: inherit;
    max-width: 1152px;
  }
`;

export const Title = styled.h3`
  ${mHeader1};
  color: ${grayScale.white} !important;
  margin-bottom: 50px;
  ${DESKTOP} {
    ${wHeader2};
    margin-bottom: 80px;
    text-align: center;
  }
`;

export const Nav = styled.nav`
  ${DESKTOP} {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 1152px;
    height: 74px;
    margin-top: 30px;
    @media (max-width: 1152px) {
      width: 950px;
    }
  }
`;

export const NavArrow = styled.div`
  display: flex;
  gap: 24px;
`;

export const NavigationButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  &[disabled] {
    cursor: not-allowed;
  }
  ${DESKTOP} {
    width: 24px;
    height: 24px;
  }
`;

export const PrevButton = styled(NavigationButton)`
  display: none;
  ${DESKTOP} {
    display: initial;
    left: 0;
  }
`;

export const NextButton = styled(NavigationButton)`
  display: none;
  ${DESKTOP} {
    display: initial;
    right: 0;
  }
`;
